<template>
  <div class="animated fadeIn">
    <!-- <div class="card p-4 mb-1"> -->
      <!-- <div class="form-group row">
        <div class="col-md-12 text-left">
          <h6 class="text-third text-bold"><i class="fas fa-phone-volume"></i> CONTATOS <span v-if="!boardArchived" style="right: 17px;display: inline-block;position: absolute;cursor: pointer" @click="onAddPhone"><i class="fas fa-plus-circle"></i></span></h6>
        </div>
      </div> -->
      <!-- <div class="form-group row"> -->
        <!-- <div class="col-md-12"> -->
          <div class="table-responsive pt-2" v-if="phones && phones.length > 0">
            <table class="table table-hover" style="'border: 1px solid #dcdede;'">
              <thead class="thead-third" style="border: solid 1px #04a791;">
                <tr>
                  <th class="text-center" style="font-size: 10px;">TELEFONE</th>
                  <th class="text-center" style="font-size: 10px;">TIPO</th>
                  <th class="text-center" style="font-size: 10px;">AÇÃO</th>
                </tr>
              </thead>
              <tbody v-if="phones && phones.length > 0">
                <tr v-for="(obj, index) in phones" :key="index">
                  <td class="text-center"><a :href="`tel:${obj.telefone}`">{{obj.telefone}}</a></td>
                  <td class="text-center" style="font-size: 11px;">{{obj.tipoContato}}</td>
                  <td @click="toastInfo" class="text-center" style="font-size: 14px; cursor: pointer;"><i :class="obj.tipoContato === 'CELULAR' ? 'fab fa-whatsapp' : 'fas fa-phone-alt'"></i></td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="2" class="text-center">{{$lang.Common.DataTable.NoRecordsFound}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Nenhum registro de contato, <strong @click="onAddPhone" style="cursor: pointer">clique para adicionar</strong>
          </div>
        <!-- </div>
      </div> -->
    <!-- </div> -->
    <ModalAddPhone ref="ModalAddPhone" :card="card" v-on:Reload="onReload"/>
  </div>
</template>
<script>
import CrmDetailsPhone from './phone.js'
export default CrmDetailsPhone
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/phones/phone.vue